import React, { createContext, useState, useEffect } from 'react';

// Create AuthContext
export const AuthContext = createContext();

// Create AuthProvider component
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    image: '',
    role:      '', 
  });

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedFirstName = localStorage.getItem('firstName');
    const storedLastName = localStorage.getItem('lastName');
    const storedImage = localStorage.getItem('image');
    const storedRole      = localStorage.getItem('role');

    if (storedToken) {
      setToken(storedToken); // Retrieve token from localStorage
    }
    if (storedFirstName && storedLastName && storedImage) {
      setUserData({
        firstName: storedFirstName,
        lastName: storedLastName,
        image: storedImage,
        role:      storedRole || '',
      });
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, setToken, userData, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
};
